import { render, staticRenderFns } from "./UscitaBancaleQrCode.vue?vue&type=template&id=2922ecec&scoped=true"
import script from "./UscitaBancaleQrCode.vue?vue&type=script&lang=js"
export * from "./UscitaBancaleQrCode.vue?vue&type=script&lang=js"
import style0 from "./UscitaBancaleQrCode.vue?vue&type=style&index=0&id=2922ecec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2922ecec",
  null
  
)

export default component.exports